import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { LinkCard } from '@amzn/stencil-react-components/card';

// const RouterLinkCard = LinkCard.withComponent(RouterLink);

// RouterLinkCard.defaultProps = {
//   ...LinkCard.defaultProps,
//   flex: '100%',
//   flexDirection: 'row',
//   justifyContent: 'center',
//   alignSelf: 'center',
//   alignItems: 'center',
//   height: '100%',
// };

// export default RouterLinkCard;

const RouterLinkCard = React.forwardRef((props, ref) => {
  const { to, ...otherProps } = props;
  
  return (
    <LinkCard
      {...otherProps}
      ref={ref}
      as={RouterLink}
      to={to}
      css={{borderRadius: 0, border: '1px solid #8b96a3'}}
    />
  );
});

RouterLinkCard.defaultProps = {
  flex: '100%',
  flexDirection: 'row',
  justifyContent: 'center',
  alignSelf: 'center',
  alignItems: 'center',
  height: '100%',
};

RouterLinkCard.displayName = 'RouterLinkCard';

export default RouterLinkCard;